import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";

import { IStoreState } from "../../reducers/types";
import { getRewardsAccountWithLargestEarnForBanner } from "../rewards/reducer";
import {
  fetchTravelWalletCreditHistory,
  fetchTravelWalletDetails,
} from "../travel-wallet/actions/actions";
import {
  listPaymentMethods,
} from "../availability/actions/actions";
import { getHotelAvailabilityCallState } from "../availability/reducer";

import { actions } from "../availability/actions";
import { WishlistAvailability } from "./component";

const mapStateToProps = (state: IStoreState) => {
  const callState = getHotelAvailabilityCallState(state);

  return {
    hotelAvailabilityCallState: callState,
    largestValueAccount: getRewardsAccountWithLargestEarnForBanner(state),
  };
};

const mapDispatchToProps = {
  fetchWishlistAvailability: actions.fetchWishlistAvailability,
  fetchTravelWalletDetails,
  fetchTravelWalletCreditHistory,
  listPaymentMethods,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type WishlistAvailabilityConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedWishlistAvailability = withRouter(
  connector(WishlistAvailability)
);
